import { ChangeEvent, useCallback, useState } from "react";
import { searchCustomer } from "src/apis/customerApi";
import { getItemPopupList } from "src/apis/itemApi";

import useUiuxStore from "src/store/useUiuxStore";
import { defaultSAL2060_R01Filter, useSAL2060_R01Store } from "./Store_SAL2060_R01";

import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

interface Props {
    onEnterKeyDown: () => void;
}

const SearchSection_SAL2060_R01 = (props: Props) => {
    const { onEnterKeyDown } = props;
    const { filter, updateFilter } = useSAL2060_R01Store();

    const { setCodeSearchModalProps } = useUiuxStore();
    const { compCdList } = useCommonCodeStore();

    // 달력 팝업 노출 여부 상태
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({
        top: 0,
        left: 0,
    });

    const custInfoHandleFocusId = 'infoCustInput_SAL2060_R01_search';
    const itemInfoHandleFocusId = 'infoItemInput_SAL2060_R01_search';

    // 사업장 선택 핸들러
    const handleCompanyChange = (selectedValue: string) => {
        updateFilter({ compCd: selectedValue });
    };


    // Info 폼 코드 검색 필드 설정
    const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
        {
            fieldName: 'customCd',
            category: '거래처',
            focusId: custInfoHandleFocusId,
            responseMapping: {
                customCd: 'customCd',
                customNm: 'customNm',
            },
            searchFunction: async (searchText: string) => {
                const customerResponse = await searchCustomer(searchText);
                return customerResponse.data.data.find(value => value.customCd === searchText);
            },
			extraFilter: () => ({
				customCd: filter.customCd || '',
				customNm: filter.customNm || '',
			}),
        },
        {
            fieldName: 'itemCd',
            category: '품목',
            focusId: itemInfoHandleFocusId,
            responseMapping: {
                itemCd: 'itemCd',
                itemNm: 'itemNm',
            },
            searchFunction: async (searchText: string) => {
                const itemResponse = await getItemPopupList(searchText, '', '', '');
                return itemResponse.data.data.find(value => value.itemCd === searchText);
            },
			extraFilter: () => ({
				itemCd: filter.itemCd || '',
				itemNm: filter.itemNm || '',
			}),
        },
    ];

    // Info 폼 이벤트 훅 사용
    const { getFieldHandlers } = useInfoFormEvents({
        editData: filter,
        setEditData: (data) => updateFilter(data as any),
        defaultData: defaultSAL2060_R01Filter,
        infoFieldConfigs,
        setCodeSearchModalProps,
        formName: 'SAL2060_R01_search'
    });

    return (
        <SearchSectionForm>
            {/* 첫 번째 줄: 사업장, 매출기간 */}
            <SearchDropDownForm
                label="사업장"
                value={filter.compCd}
                optionList={compCdList}
                onChangeValue={handleCompanyChange}
            />
            <SearchDateRangeForm
                label="매출기간"
                wrapperOption={{
                    titleStyle:
                        'h-[24px] flex items-center truncate shrink-0 w-[80px] min-w-[80px]',
                }}
                visible={pickerVisible}
                setVisible={setPickerVisible}
                dateRange={filter.dateRange}
                setDateRange={(dateRange) => updateFilter({ dateRange })}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />

            {/* 두 번째 줄: 거래처, 품목코드 */}
            <SearchCodeModalForm
                label="거래처"
                value={filter.customCd}
                valueLabel={filter.customNm}
                handleFoucsId={custInfoHandleFocusId}
                onChange={getFieldHandlers('customCd').onChange}
                onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
                onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
            />
            <SearchCodeModalForm
                label="품목코드"
                value={filter.itemCd}
                valueLabel={filter.itemNm}
                handleFoucsId={itemInfoHandleFocusId}
                onChange={getFieldHandlers('itemCd').onChange}
                onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
                onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
            />
        </SearchSectionForm>
    );
};

export { SearchSection_SAL2060_R01 };
export default SearchSection_SAL2060_R01;
